import { __assign } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { default as MuiStepContent } from '@material-ui/core/StepContent';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        active: (_a = {
                marginBottom: '6px'
            },
            _a[theme.breakpoints.up('sm')] = {
                marginBottom: 0,
            },
            _a),
    });
});
export var StepContent = React.forwardRef(function (props, ref) {
    var _a;
    var active = props.active;
    var classes = useStyles(props);
    return (React.createElement(MuiStepContent, __assign({ ref: ref, className: clsx((_a = {},
            _a[classes.active] = active,
            _a)) }, props)));
});
export default StepContent;
//# sourceMappingURL=StepContent.js.map